// @flow
import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import handleReduce from '~/core/state/handle-reduce';
import { RECEIVED_WEATHER } from './constants';

const defaultState = fromJS({
    icon: '',
    description: '',
    temperature: {}
});

const reducers = {
    [RECEIVED_WEATHER]: handleReduce((state, { payload }) => fromJS(payload.weather))
};

export default handleActions(reducers, defaultState);



// WEBPACK FOOTER //
// ./src/core/state/weather/index.js